import IconLightningGradient, {
	IconLightningGradientProps as _IconLightningGradientProps,
} from './IconLightningGradient';

export { IconLightningGradient };
export type IconLightningGradientProps = _IconLightningGradientProps;
